import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Ban, Search, Trash2, Package, FlaskConical } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { SugerenciasLibre } from "./SugerenciasLibre";

function Buscador({ modo, onPick }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    const t = q.trim();
    if (t.length < 2) { setItems([]); return undefined; }
    const h = setTimeout(() => {
      const req = modo === "cn" ? api.get("/productos/buscar", { params: { q: t } }).then((r) => r.data.items.map((i) => ({ valor: i.cn, descripcion: i.descripcion, extra: i.laboratorio })))
        : api.get("/libre-excluidos/laboratorios", { params: { q: t } }).then((r) => r.data.laboratorios.map((l) => ({ valor: l, descripcion: l })));
      req.then(setItems).catch(() => setItems([]));
    }, 250);
    return () => clearTimeout(h);
  }, [q, modo]);
  return (
    <div className="relative">
      <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
      <input className="input w-full" style={{ paddingLeft: 32 }} value={q} onChange={(e) => setQ(e.target.value)} data-testid="libre-excl-buscar"
             placeholder={modo === "cn" ? "Busca por nombre o CN (p. ej. Wegovy, Mounjaro)…" : "Busca un laboratorio…"} />
      {items.length > 0 && (
        <div className="absolute z-20 mt-1 w-full max-h-64 overflow-auto bg-white border border-slate-200 rounded-lg shadow-lg" data-testid="libre-excl-resultados">
          {items.map((i, n) => (
            <button key={i.valor} onClick={() => { onPick(i); setQ(""); setItems([]); }} data-testid={`libre-excl-resultado-${n}`}
                    className="w-full text-left px-3 py-2 text-sm hover:bg-sky-50 border-b border-slate-100 last:border-0">
              {modo === "cn" && <span className="font-mono text-xs text-slate-400 mr-2">{i.valor}</span>}{i.descripcion}
              {i.extra && <span className="block text-[11px] text-slate-400">{i.extra}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function ExcepcionesLibre({ onChange, importId }) {
  const [lista, setLista] = useState([]);
  const [modo, setModo] = useState("cn");
  const [version, setVersion] = useState(0);
  const load = () => api.get("/libre-excluidos").then((r) => { setLista(r.data.excluidos); setVersion((v) => v + 1); }).catch(() => {});
  useEffect(() => { load(); }, []);

  const anadir = async (i) => {
    try {
      await api.post("/libre-excluidos", { tipo: modo, valor: i.valor, descripcion: i.descripcion });
      toast.success("Quitado de la venta libre de los incentivos");
      await load();
      onChange?.();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo añadir"); }
  };
  const quitar = async (e) => {
    await api.delete(`/libre-excluidos/${e.id}`).catch(() => {});
    await load();
    onChange?.();
  };

  return (
    <div className="card p-5" data-testid="libre-excepciones">
      <div className="flex items-center gap-2 mb-1"><Ban size={15} className="text-red-500" /><h3 className="font-display font-bold">Excepciones a la venta libre</h3></div>
      <p className="text-xs text-slate-500 mb-3">Artículos que se cobran como venta libre pero no llevan trabajo de venta (p. ej. sustitutos de Ozempic con receta privada).
        No cuentan en el incentivo grupal ni en el individual, ni este mes ni en el mismo mes del año anterior.</p>
      <div className="inline-flex rounded-lg border border-slate-200 p-0.5 mb-2">
        {[["cn", "Artículo", Package], ["lab", "Laboratorio entero", FlaskConical]].map(([k, l, I]) => (
          <button key={k} onClick={() => setModo(k)} data-testid={`libre-excl-modo-${k}`}
                  className={"px-3 py-1.5 text-xs font-semibold rounded-md inline-flex items-center gap-1 transition-colors " + (modo === k ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100")}><I size={12} />{l}</button>
        ))}
      </div>
      <Buscador modo={modo} onPick={anadir} />
      {!lista.length ? <p className="text-xs text-slate-400 mt-3" data-testid="libre-excl-vacio">No hay excepciones: cuenta toda la venta libre.</p> : (
        <ul className="mt-3 space-y-1.5" data-testid="libre-excl-lista">
          {lista.map((e) => (
            <li key={e.id} className="flex items-center gap-2 text-sm bg-slate-50 rounded-md px-3 py-1.5" data-testid={`libre-excl-${e.id}`}>
              <span className={"text-[10px] font-bold px-1.5 py-0.5 rounded " + (e.tipo === "lab" ? "bg-violet-100 text-violet-700" : "bg-sky-100 text-sky-700")}>{e.tipo === "lab" ? "LAB" : e.valor}</span>
              <span className="flex-1 truncate" title={e.descripcion}>{e.descripcion || e.valor}</span>
              <button onClick={() => quitar(e)} className="text-red-400 hover:text-red-600" title="Volver a contar" data-testid={`libre-excl-quitar-${e.id}`}><Trash2 size={14} /></button>
            </li>
          ))}
        </ul>
      )}
      <SugerenciasLibre importId={importId} version={version} onAdded={async () => { await load(); onChange?.(); }} />
    </div>
  );
}
